module.exports = __webpack_public_path__ + "static/media/job-status.40b3917c.png";